'use client';

import { useNavigationGuard } from '@/hooks/useNavigationGuard';

interface NavigationGuardProps {
  children: React.ReactNode;
}

export function NavigationGuard({ children }: NavigationGuardProps) {
  // This hook will handle the navigation guard logic
  useNavigationGuard();
  
  return <>{children}</>;
}
